// Browser compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#Browser_compatibility
//
// Quirksmode Reference
// http://www.quirksmode.org/js/xmlhttp.html
//
// Code excerpt below is taken from:
// https://gist.github.com/jed/993585#gistcomment-40084

export default class XhrAdapter {
  constructor(options = {}){
    this._callbacks = [];
    this._dataType = options["dataType"];

    try {
      this._instance = new XMLHttpRequest();
    } catch(e) {
      this._instance = XhrAdapter.nullObject();
      console.error(e);
    }
  }

  static nullObject(){
    return {
      onReadyStateChange: this.noop,
      readyState: this.noop,
      status: this.noop,
      open: this.noop,
      onDone: this.noop,
      onSuccess: this.noop,
      onError: this.noop,
      response: this.noop,
      responseJSON: this.noop,
      send: this.noop,
      isSuccess: this.noop,
      dataType: this.noop,
      instance: this.noop,
      callbacks: this.noop
    };
  }

  static noop(){}

  instance(){
    return this._instance;
  }

  callbacks(){
    return this._callbacks;
  }

  dataType(){
    return this._dataType;
  }

  onReadyStateChange(callback){
    this.callbacks().push(callback);
    if (typeof this.instance().onreadystatechange != "function") {
      this.instance().onreadystatechange = function(){
        for (let i in this.callbacks()) {
          let result = (this.dataType() === "json") ? this.responseJSON() : this.response();
          this.callbacks()[i](result, this);
        }
      }.bind(this);
    }
  }

  onDone(callback){
    this.onReadyStateChange(function(response, xhr){
      if (this.readyState() == 4) {
        callback(response, xhr);
      }
    }.bind(this));
  }

  onSuccess(callback){
    this.onReadyStateChange(function(response, xhr){
      if (this.readyState() == 4 && this.isSuccess()) {
        callback(response, xhr);
      }
    }.bind(this));
  }

  onError(callback){
    this.onReadyStateChange(function(response, xhr){
      if (this.readyState() == 4 && !this.isSuccess()) {
        callback(response, xhr);
      }
    }.bind(this));
  }

  readyState(){
    return this.instance().readyState;
  }

  status(){
    return this.instance().status;
  }

  response(){
    return this.instance().response;
  }

  responseJSON(){
    try {
      return JSON.parse(this.response());
    } catch(e) {
      return {};
    }
  }

  open(method, url){
    this._url = url;
    this.instance().open(method, url);
  }

  timeout(timeout) {
    this.instance().timeout = timeout;
  }

  url(){
    return this._url;
  }

  send(formData){
    this.instance().send(formData);
  }

  isSuccess(){
    return (this.status() >= 200 && this.status() < 300) || this.status() == 304;
  }

  setRequestHeader(key, value) {
    this.instance().setRequestHeader(key, value);
  }
}
